// extracted by mini-css-extract-plugin
module.exports = {"container":"Image_container__xePlt"};